import styled from '@emotion/styled';
import { Typography } from 'common/components/antd/Typography/Typography';
import { EnhancedSelect as _EnhancedSelect } from 'common/components/EnhancedSelect/EnhancedSelect';

export const SFromInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
`;

export const SInputsGroup = styled.div`
  background: transparent;
  padding: 8px;
`;

export const SContainer = styled.div`
  width: 100%;
  padding: 13px;
`;

export const STitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
`;

export const SControl = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  //margin-block: 0;
  //
  //.ant-picker {
  //  width: 100%;
  //}
  //
  //& .select-accounts-customers .ant-select-selector {
  //  padding: 0 6px;
  //}
  //& .select-accounts-customers .ant-select-selection-item {
  //  padding-right: 12px;
  //  font-size: 9px !important;
  //}
`;

export const SEnhancedSelect = styled(_EnhancedSelect)<{ currencySelect?: boolean }>`
  width: 100%;
  &:not(:first-of-type) .ant-input {
    border-left: 0;
  }
`;

export const SSelectRow = styled.div`
  margin-top: 0;
  display: flex;

  // & ${SEnhancedSelect}:first-of-type {
  //   & .ant-select-selection-item {
  //     font-size: 13px;
  //   }
  // }
  //
  // & .ant-input {
  //   width: 100%;
  // }
  //
   & .ant-input:first-of-type {
     border-left: none;
   }

   .ant-form-item {
     margin: 0;
   }
`;

export const SLabel = styled(Typography.Text)`
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
`;

export const SButtonsWrapper = styled(Typography.Text)`
  width: 100%;
  display: flex;
  justify-content: end;
  gap: 20px;
  margin: 20px 0;
`;
